// Source unique des avantages affichés par formule (démo + page Abonnement). Doit refléter les droits réellement codés côté serveur.
export const PLAN_FEATURES = {
  free: ["free_f1", "free_f2", "free_f3", "free_f4", "free_f5", "demo_plan_primary_only"],
  plus: ["plus_f1", "plus_f2", "plus_f3", "plus_f4", "demo_plan_household_profiles"],
  premium: ["prem_f1", "prem_f2", "prem_f3"],
};
